export default __webpack_public_path__ + "static/media/feline.b11aba33.svg";